import React, { createContext, useEffect, useState } from 'react';
import { getMe, getFlags, heartbeat, login as betaLogin, register as betaRegister, logout as betaLogout } from '../services/beta';
import { getAccessToken } from '../services/api';

export const BetaContext = createContext(null);

const DEVICE_KEY = 'beta_device_id';

const getDeviceId = () => {
  let deviceId = localStorage.getItem(DEVICE_KEY);
  if (!deviceId) {
    deviceId = `device_${Math.random().toString(36).slice(2, 10)}_${Date.now()}`;
    localStorage.setItem(DEVICE_KEY, deviceId);
  }
  return deviceId;
};

export const BetaProvider = ({ children }) => {
  const [betaUser, setBetaUser] = useState(null);
  const [flags, setFlags] = useState({});
  const [loading, setLoading] = useState(true);

  const deviceId = getDeviceId();
  const env = process.env.REACT_APP_ENV || 'beta';

  const loadMe = async () => {
    try {
      const response = await getMe();
      setBetaUser(response.user);
    } catch (error) {
      setBetaUser(null);
    }
  };

  const loadFlags = async () => {
    try {
      const response = await getFlags({ env, deviceId });
      setFlags(response.flags || {});
    } catch (error) {
      setFlags({});
    }
  };

  const sendHeartbeat = async () => {
    try {
      await heartbeat({ deviceId, platform: 'web', appVersion: process.env.REACT_APP_VERSION });
    } catch (error) {
      // ignore
    }
  };

  useEffect(() => {
    const init = async () => {
      const token = getAccessToken();
      if (token) {
        await loadMe();
        await loadFlags();
        await sendHeartbeat();
      }
      setLoading(false);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (payload) => {
    const response = await betaLogin({ ...payload, deviceId, appVersion: process.env.REACT_APP_VERSION });
    setBetaUser(response.user);
    await loadFlags();
    await sendHeartbeat();
    return response;
  };

  const register = async (payload) => {
    const response = await betaRegister({ ...payload, deviceId, appVersion: process.env.REACT_APP_VERSION });
    setBetaUser(response.user);
    await loadFlags();
    await sendHeartbeat();
    return response;
  };

  const logout = async () => {
    const refreshToken = localStorage.getItem('beta_refresh_token');
    if (refreshToken) {
      await betaLogout(refreshToken);
    }
    setBetaUser(null);
    setFlags({});
  };

  const value = {
    betaUser,
    flags,
    loading,
    login,
    register,
    logout,
    refreshFlags: loadFlags,
    deviceId,
    env
  };

  return (
    <BetaContext.Provider value={value}>
      {children}
    </BetaContext.Provider>
  );
};
